import { Component, OnInit, OnDestroy } from '@angular/core'
import { NgForm } from '@angular/forms'
import BaseEditationComponent from 'src/app/class/BaseEditationComponent'

@Component({
  selector: 'app-settings',
  templateUrl: './detail.component.html',
  styleUrls: ['./../../../app.component.css']
})
export default class DetailForm extends BaseEditationComponent implements OnInit, OnDestroy {
  data = {
    id: null, num: 0, name: '', ipAddress: ''
  }
  requiredFields = ['num', 'name']
  objectKeys = Object.keys;
  fmFieldMappings = {
    // imageField: 'image',
  }

  getCommEntity() {
    return this.comm.provozovny();
  }

  getHeading() {
    return this.id ? this.data.name ? `Editace provozovny ${this.data.name}` : 'Načítám provozovny...' : 'Nová provozovna'
  }

  afterSave() {
    this.router.navigate(['/system/nastaveni/provozovna']);
  }

  parseFormToData(form: NgForm) {
    if (form.value.num!=''){this.data.num = +form.value.num};
    if (form.value.name!=''){this.data.name = form.value.name};
    if (form.value.ipAddress!=''){this.data.ipAddress = form.value.ipAddress};
  }
}
